import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'

import {LinkSchema} from './link'
import {LinkGroupSchema} from './linkGroup'

export const SubnavSchema = buildEntrySchemaFor('subnav', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      subNavHeading: safeOptional(LinkSchema),
      subNavSubHeading: safeOptional(LinkSchema),
      subNavLinks: safeOptional(z.array(LinkSchema.or(LinkGroupSchema))),
      subNavCta: safeOptional(LinkSchema),
    }),
  ),
})

export type Subnav = z.infer<typeof SubnavSchema>
